export class FilePrescModel {
    file: string
    path: string
    url: string

    constructor(file: string, path: string, url: string) {
        this.file = file
        this.path = path
        this.url = url
    }
}